<template lang="pug">
include /mixins
+b.trip-preview-chart
  svg(width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg")
    circle(
      opacity="0.4"
      cx="22"
      cy="22"
      r="20"
      stroke="#FF7A00"
      stroke-width="4"
      fill="none"
    )
    circle(
      cx="22"
      cy="22"
      r="20"
      :stroke="isFullProgress ? '#00C48C' : '#FF7A00'"
      stroke-width="4"
      fill="none"
      stroke-linecap="round"
      transform="rotate(-90 22 22)"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="dashOffset"
    )
  +e.text.P(
    :style='{"--color": isFullProgress ? "#00C48C" : "#FF7A00"}'
  ) {{ isFullProgress ? '100%' : progress + '%' }}
</template>

<script>

import { tripRetrieveResource } from '@api/vendor.service'

export default {
  name: 'TripProgressChartMini',
  props: {
    trip_label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      trip: null,
    }
  },
  computed: {
    isFullProgress() {
      return this.progress >= 100
    },
    normalizedProgress() {
      return Math.min(Math.max(this.progress, 0), 100)
    },
    circumference() {
      return 2 * Math.PI * 20
    },
    dashOffset() {
      return this.circumference * (1 - this.normalizedProgress / 100)
    },
    progress() {
      if (!this.trip || !this.trip.props) return 0

      const value = Number(this.trip.props.trip_potential_participant.props.total_actual_sale)
      const from = Number(this.trip.props.trip_potential_participant.props.purchase_amount)
      return Math.round((Number(value) / Number(from)) * 100) || 0;
    },
  },
  mounted() {
    this.fetchTrip()
  },
  methods: {
    async fetchTrip() {
      try {
        const { data } = (await tripRetrieveResource.execute({ label: this.trip_label }))
        this.trip = data
      } catch (error) {
        console.error('Error fetching trip data:', error)
      }
    },
  },
}
</script>
